import { decoratedAppRouteChildren } from "./routeRegistry";
import { routeNavigationItems } from "./metadata";
import type * as Dtos from "src/dtos/Tmd.dtos";

/** Decorated top-level destinations consumed by the application shell. */
export const navigationRoutes = decoratedAppRouteChildren;

export const primaryNavigationItems = (permissions: readonly Dtos.PersonnelTmdPermissions[] = []) => routeNavigationItems(navigationRoutes, permissions);
